import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useLocation } from 'react-router-dom';
import { useTransactionCertificateStore } from '../../../store/transaction-certificates.store';
import { isAdmin } from '../../utils/admin-utils';

/**
 * Admin banner - shows admin mode indicator when viewing other CB-IDs
 * No navigation button - use sidebar Admin Dashboard icon to return
 */
const AdminBanner: React.FC = () => {
  const location = useLocation();
  const { cbLicensingCode, originalAdminCBID } = useTransactionCertificateStore();
  

  // Only show banner if user is an admin (using originalAdminCBID check)
  const userIsAdmin = isAdmin();
  
  // Don't show banner on admin page itself
  if (!userIsAdmin || location.pathname === '/admin') {
    return null;
  }

  const isViewingOwnCBID = cbLicensingCode === originalAdminCBID;

  return (
    <Box 
      sx={{ 
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        width: '100%',
      }}
    >
      <Alert 
        severity="info"
        icon={<AdminPanelSettingsIcon />}
        sx={{
          borderRadius: 0,
          '& .MuiAlert-message': {
            width: '100%',
          }
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Typography variant="body2">
            {isViewingOwnCBID ? (
              <>
                <strong>Admin Mode:</strong> Viewing your own CB-ID: <strong>{cbLicensingCode}</strong>
                {' '}&nbsp;|&nbsp; ✅ <em>Edit access enabled — you can create, edit and delete.</em>
              </>
            ) : (
              <>
                <strong>Admin Mode:</strong> Viewing data for CB-ID: <strong>{cbLicensingCode}</strong>
                {' '}
                | Your admin CB-ID: <strong>{originalAdminCBID}</strong>
                {' '}
                &nbsp;|&nbsp; 🔒 <em>View only — create, edit and delete functionalities are blocked.</em>
              </>
            )}
          </Typography>
        </Box>
      </Alert>
    </Box>
  );
};

export default AdminBanner;
